export const GET_PRODUCTS_OPTIONS = 'providers/ListsOptionsProvider/GET_PRODUCTS_OPTIONS';
export const GET_PRODUCTS_OPTIONS_BY_PAGINATION = 'providers/ListsOptionsProvider/GET_PRODUCTS_OPTIONS_BY_PAGINATION';
export const GET_PRODUCTS_OPTIONS_BY_FILTER = 'providers/ListsOptionsProvider/GET_PRODUCTS_OPTIONS_BY_FILTER';
// autocomplete
export const GET_PRODUCTS_AUTOCOMPLETE = 'providers/ListsOptionsProvider/GET_PRODUCTS_AUTOCOMPLETE';
export const GET_PRODUCTS_AUTOCOMPLETE_BY_PAGINATION =
  'providers/ListsOptionsProvider/GET_PRODUCTS_AUTOCOMPLETE_BY_PAGINATION';
export const GET_PRODUCTS_AUTOCOMPLETE_BY_FILTER = 'providers/ListsOptionsProvider/GET_PRODUCTS_AUTOCOMPLETE_BY_FILTER';
